import(/* webpackMode: "eager" */ "/var/www/vhosts/indianayurvedicproducts.com/httpdocs/src/app/shipping-policy/page.tsx");
